import React, { useState, useEffect, useRef } from 'react';



import IaPhasedLoading from './IaPhasedLoading';

import WorkoutCompositionPicker from './WorkoutCompositionPicker';
import { DEFAULT_COMPOSITION } from '../constants/workoutCompositionSegments';

const FULL_SESSION_COMPOSITION = ['aquecimento', 'treino_principal', 'desaquecimento'];







/**



 * Treinos sugeridos (onboarding): configuração, lista expansível, rascunho, aplicar treino.



 */



export default function IaOnboardingPackModal({



  open,



  onClose,



  suggestions = [],



  loading = false,



  jobPhase = 'recebidos',



  engineLabel = 'IA',



  error = '',



  desiredCount = '3',



  onDesiredCountChange,



  globalNotes = '',



  onGlobalNotesChange,



  extraDetail = '',



  onExtraDetailChange,



  workoutComposition,



  onWorkoutCompositionChange,



  perWorkoutNotes = [],



  onPerWorkoutNoteChange,



  onGenerate,



  onRegenerate,



  onRemoveSuggestion,



  onClearDraft,

  onApplyOne,

  onApplyAll,

  mode = 'full',

  canGenerate = true,

  draftSavedAt = null,

  embedded = false,

}) {



  const [applyingIdx, setApplyingIdx] = useState(null);



  const [applyingAll, setApplyingAll] = useState(false);



  const [msg, setMsg] = useState('');

  const [showAdvancedComposition, setShowAdvancedComposition] = useState(false);



  const resultsAnchorRef = useRef(null);



  const hasResults = Array.isArray(suggestions) && suggestions.length > 0;



  const showLoading = loading && !hasResults;



  const showForm = mode !== 'review' && !loading && !hasResults;



  const busy = applyingIdx !== null || applyingAll;



  useEffect(() => {

    if (!open || !hasResults || showLoading) return;

    const frameId = requestAnimationFrame(() => {

      resultsAnchorRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    });

    return () => cancelAnimationFrame(frameId);

  }, [open, hasResults, showLoading, suggestions.length]);







  const applyOne = async (suggestion, idx) => {
    if (!onApplyOne) return;
    setMsg('');
    setApplyingIdx(idx);
    try {
      const { message } = await onApplyOne(suggestion, idx);
      setMsg(message || `Treino "${suggestion.name}" criado.`);
    } catch (e) {
      setMsg(e.response?.data?.error || e.message || 'Erro ao criar treino');
    } finally {
      setApplyingIdx(null);
    }
  };







  const applyAll = async () => {
    if (!onApplyAll) return;
    setMsg('');
    setApplyingAll(true);
    try {
      const { message } = await onApplyAll();
      setMsg(message || 'Treinos criados.');
    } catch (e) {
      setMsg(e.message || e.response?.data?.error || 'Erro ao criar treinos');
    } finally {
      setApplyingAll(false);
    }
  };







  const handleRegenerate = () => {



    setMsg('');



    if (onRegenerate) onRegenerate();



  };







  const panelClass = embedded
    ? 'w-full overflow-y-auto'
    : 'card max-h-[92vh] w-full max-w-lg overflow-y-auto border-iron-accent/50';

  const panel = (
      <div
        className={panelClass}
        role={embedded ? undefined : 'dialog'}
        aria-modal={embedded ? undefined : 'true'}
      >
        {!embedded && (
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            <h2 className="font-display text-xl tracking-wide text-iron-accent">Treinos sugeridos</h2>
            <p className="mt-1 font-mono text-[10px] text-iron-muted">Motor · {engineLabel}</p>
          </div>
          <button type="button" onClick={onClose} className="text-iron-muted hover:text-iron-text px-1" aria-label="Fechar">
            ✕
          </button>
        </div>
        )}







        {error && (



          <div className="mb-4 rounded-lg border border-iron-danger/40 bg-iron-danger/10 px-3 py-2 text-sm text-iron-danger">



            {error}



          </div>



        )}







        {showLoading && (



          <div className="mb-4 rounded-xl border border-iron-accent/35 bg-iron-surface/90 p-4">



            <p className="mb-3 font-mono text-[10px] uppercase tracking-wide text-iron-muted">



              Gerando planos com base no seu perfil…



            </p>



            <IaPhasedLoading phase={jobPhase} />



            <p className="mt-3 font-mono text-[10px] text-iron-muted">



              Pode levar até 1 minuto. Mantenha esta janela aberta.



            </p>



          </div>



        )}







        {showForm && (



          <div className="mb-4 space-y-3 rounded-xl border border-iron-border bg-iron-surface/80 p-3">



            <p className="font-mono text-[10px] uppercase tracking-wide text-iron-muted">



              Antes de gerar



            </p>



            <label className="flex cursor-pointer items-start gap-2 rounded-lg border border-iron-border bg-iron-bg/60 px-3 py-2">
              <input
                type="checkbox"
                className="mt-0.5"
                checked={
                  Array.isArray(workoutComposition) &&
                  workoutComposition.includes('aquecimento') &&
                  workoutComposition.includes('desaquecimento')
                }
                onChange={(e) => {
                  if (e.target.checked) {
                    onWorkoutCompositionChange?.(FULL_SESSION_COMPOSITION, { explicit: true });
                  } else {
                    onWorkoutCompositionChange?.([...DEFAULT_COMPOSITION], { explicit: false });
                    setShowAdvancedComposition(false);
                  }
                }}
              />
              <span className="font-mono text-xs text-iron-text">
                Sessão completa (aquecimento + desaquecimento)
              </span>
            </label>
            <p className="font-mono text-[10px] text-iron-muted">
              Com toggle desligado, a IA pode sugerir aquecimento conforme o seu perfil.
            </p>
            {!showAdvancedComposition ? (
              <button
                type="button"
                className="font-mono text-[10px] uppercase tracking-wide text-iron-accent hover:underline"
                onClick={() => setShowAdvancedComposition(true)}
              >
                Personalizar segmentos
              </button>
            ) : (
              <WorkoutCompositionPicker
                value={workoutComposition}
                onChange={(next) => onWorkoutCompositionChange?.(next, { explicit: true })}
                title="Composição do treino"
              />
            )}



            <label className="block">



              <span className="font-mono text-[10px] text-iron-muted">Quantidade de treinos (2–4)</span>



              <input



                type="number"



                min={2}



                max={4}



                value={desiredCount}



                onChange={(e) => onDesiredCountChange?.(e.target.value)}



                className="mt-1 w-full rounded-lg border border-iron-border bg-iron-bg px-3 py-2 font-mono text-sm text-iron-text"



              />



            </label>



            <label className="block">



              <span className="font-mono text-[10px] text-iron-muted">Contexto geral</span>



              <textarea



                value={globalNotes}



                onChange={(e) => onGlobalNotesChange?.(e.target.value)}



                rows={3}



                placeholder="Ex.: foco em membros superiores, tempo limitado…"



                className="mt-1 w-full rounded-lg border border-iron-border bg-iron-bg px-3 py-2 font-mono text-xs text-iron-text placeholder:text-iron-muted"



              />



            </label>



            <label className="block">



              <span className="font-mono text-[10px] text-iron-muted">Pedido desta geração (opcional)</span>



              <textarea



                value={extraDetail}



                onChange={(e) => onExtraDetailChange?.(e.target.value)}



                rows={2}



                placeholder="Limitações, equipamento, dias disponíveis…"



                className="mt-1 w-full rounded-lg border border-iron-border bg-iron-bg px-3 py-2 font-mono text-xs text-iron-text placeholder:text-iron-muted"



              />



            </label>



            <button



              type="button"



              disabled={loading || !canGenerate}



              onClick={() => {



                setMsg('');



                onGenerate?.();



              }}



              className="btn-primary btn-sm w-full"



            >



              Gerar com IA



            </button>



          </div>



        )}







        {msg && (



          <div className="mb-3 rounded-lg border border-iron-border bg-iron-surface px-3 py-2 font-mono text-xs text-iron-muted">



            {msg}



          </div>



        )}







        {hasResults && (



          <>



            <div

              ref={resultsAnchorRef}

              className="mb-4 rounded-xl border border-iron-accent/40 bg-iron-accent/10 px-3 py-3"

            >

              <p className="font-display text-base text-iron-accent">

                {suggestions.length} treino{suggestions.length === 1 ? '' : 's'} gerado

                {suggestions.length === 1 ? '' : 's'}

              </p>

              <p className="mt-1 font-mono text-[10px] text-iron-muted">

                Expanda cada card, revise os exercícios e crie os treinos.

              </p>

              {mode === 'review' && draftSavedAt ? (
                <p className="mt-1 font-mono text-[10px] text-iron-muted/80">
                  Rascunho guardado em{' '}
                  {new Date(draftSavedAt).toLocaleString('pt-BR', {
                    dateStyle: 'short',
                    timeStyle: 'short',
                  })}
                </p>
              ) : null}

            </div>



            <div className="mb-3 flex flex-wrap gap-2">



              {suggestions.length > 1 && (

                <button

                  type="button"

                  className="btn-primary btn-sm"

                  onClick={applyAll}

                  disabled={showLoading || busy}

                >

                  {applyingAll ? 'Criando todos…' : 'Criar todos os treinos'}

                </button>

              )}



              {mode !== 'review' && onRegenerate ? (
              <button

                type="button"

                className="btn-secondary btn-sm"

                onClick={handleRegenerate}

                disabled={showLoading || busy}

              >



                Gerar novamente



              </button>
              ) : null}



              <button



                type="button"



                className="btn-sm rounded-md border border-iron-danger/40 text-iron-danger hover:bg-iron-danger/10"



                onClick={() => {



                  setMsg('');



                  onClearDraft?.();



                }}



                disabled={busy}



              >



                Limpar rascunho



              </button>



            </div>







            <div className="space-y-4">



              {(suggestions || []).map((sug, idx) => (



                <div key={`${sug.name}-${idx}`} className="rounded-xl border border-iron-border bg-iron-card/80 p-3">



                  <details className="group">



                    <summary className="cursor-pointer font-display text-base text-iron-text list-none [&::-webkit-details-marker]:hidden">



                      <span className="inline-flex w-full items-center justify-between gap-2">



                        <span>{sug.name}</span>



                        <span className="font-mono text-[10px] text-iron-accent">{(sug.items || []).length} exercícios ▾</span>



                      </span>



                    </summary>



                    {sug.description && <p className="mt-2 text-xs text-iron-muted">{sug.description}</p>}



                    <ul className="mt-2 space-y-2 border-t border-iron-border pt-2">



                      {(sug.items || []).map((it, j) => (



                        <li key={`${it.name}-${j}`} className="font-mono text-[11px] text-iron-text">



                          <span className="text-iron-accent">{it.name}</span>



                          {it.muscleGroup ? (



                            <span className="text-iron-muted"> · {it.muscleGroup}</span>



                          ) : null}



                          <span className="block text-[10px] text-iron-muted">



                            {it.sets != null ? `${it.sets} séries` : ''}



                            {it.reps != null ? ` · ${it.reps}` : ''}



                            {it.restSeconds != null ? ` · descanso ~${it.restSeconds}s` : ''}



                          </span>



                          {it.notes ? <span className="block text-[10px] text-iron-muted">{it.notes}</span> : null}



                        </li>



                      ))}



                    </ul>



                  </details>







                  {mode !== 'review' && onRegenerate ? (
                  <label className="mt-3 block">



                    <span className="font-mono text-[10px] text-iron-muted">Modificações para este treino (usadas ao regenerar)</span>



                    <textarea



                      value={perWorkoutNotes[idx] || ''}



                      onChange={(e) => onPerWorkoutNoteChange?.(idx, e.target.value)}



                      rows={2}



                      className="mt-1 w-full rounded-lg border border-iron-border bg-iron-bg px-2 py-1.5 font-mono text-[11px] text-iron-text"



                      placeholder="Ex.: menos exercícios de ombro…"



                    />



                  </label>
                  ) : null}







                  <div className="mt-3 flex gap-2">



                    <button



                      type="button"



                      disabled={loading || busy}



                      onClick={() => applyOne(sug, idx)}



                      className="btn-primary btn-sm flex-1"



                    >



                      {applyingIdx === idx ? 'Criando…' : 'Criar este treino'}



                    </button>



                    <button



                      type="button"



                      className="btn-sm rounded-md border border-iron-border text-iron-muted hover:text-iron-danger"



                      disabled={busy}



                      onClick={() => {



                        setMsg('');



                        onRemoveSuggestion?.(idx);



                      }}



                    >



                      Excluir



                    </button>



                  </div>



                </div>



              ))}



            </div>



          </>



        )}







        {!embedded && (
        <button type="button" onClick={onClose} className="btn-secondary btn-sm mt-6 w-full">
          Fechar
        </button>
        )}
      </div>
  );

  if (!open) return null;
  if (embedded) return panel;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/75 p-4 backdrop-blur-sm">
      {panel}
    </div>
  );



}



